export function formatRelativeTime(dateString, now = Date.now()) {
  const value = new Date(dateString)
  if (Number.isNaN(value.getTime())) return ''

  const diffMs = now - value.getTime()
  const diffMins = Math.floor(diffMs / 60000)

  if (diffMins < 1) return 'just now'
  if (diffMins < 60) return `${diffMins}m ago`

  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`

  return `${Math.floor(diffHours / 24)}d ago`
}
